module.exports = require("vtk.js/Sources/IO/XML/XMLImageDataReader");